/**
 * User Stories Types (State-Based FMEA)
 *
 * Defines operational user stories, workflow steps, failure points (off-ramps),
 * and multi-layer mitigation strategies that link operational workflows to risk analysis.
 */
/**
 * Mitigation type enum
 */
export var MitigationType;
(function (MitigationType) {
    MitigationType["MECHANICAL"] = "MECHANICAL";
    MitigationType["ELECTRONIC"] = "ELECTRONIC";
    MitigationType["SOFTWARE"] = "SOFTWARE";
    MitigationType["PROCEDURAL"] = "PROCEDURAL";
})(MitigationType || (MitigationType = {}));
/**
 * Mitigation status enum (KEEP, PARK, REMOVE approach)
 */
export var MitigationStatus;
(function (MitigationStatus) {
    MitigationStatus["KEEP"] = "KEEP";
    MitigationStatus["PARK"] = "PARK";
    MitigationStatus["REMOVE"] = "REMOVE";
})(MitigationStatus || (MitigationStatus = {}));
/**
 * Type guard for MitigationType
 */
export function isMitigationType(value) {
    return Object.values(MitigationType).includes(value);
}
/**
 * Type guard for MitigationStatus
 */
export function isMitigationStatus(value) {
    return Object.values(MitigationStatus).includes(value);
}
//# sourceMappingURL=user-stories-v2.types.js.map